import axiosHttp from "../../services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchStatusList = createAsyncThunk("fetchStatusList", async ({ identifier, sub }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`status/list?identifier=${identifier}&sub=${sub}`, config);

	return response.data.data;
});

const statusListSlice = createSlice({
	name: "statusList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchStatusList.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchStatusList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchStatusList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default statusListSlice.reducer;
